/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SdkToken } from '../../models/sdk-token';

export interface ProfileSdkAuthTokenGet$Params {
}

export function profileSdkAuthTokenGet(http: HttpClient, rootUrl: string, params?: ProfileSdkAuthTokenGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<SdkToken>> {
  const rb = new RequestBuilder(rootUrl, profileSdkAuthTokenGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<SdkToken>;
    })
  );
}

profileSdkAuthTokenGet.PATH = '/Profile/SDKAuthToken';
